import { Api } from '../base/Api';
import { Injectable } from '@angular/core';
import { Address } from 'src/app/models/Address';

@Injectable({
    providedIn: 'root'
})
export class AddressApi extends Api<Address> {
}
